import Gateway from "./Gateway";

export default Gateway;
